import { Box, BoxProps, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { LogoExtendedIcon } from '../../../icons';

export type FooterProps = BoxProps;

/**
 * Footer component
 * @private
 *
 * @param boxProps
 */
export const Footer: React.FC<FooterProps> = boxProps => {
  const { t } = useTranslation('forms');

  return (
    <Box {...boxProps}>
      <Stack spacing="sm">
        <Box
          sx={theme => ({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            columnGap: theme.spacing.sm,
            opacity: 0.4,
          })}
        >
          <Text>{t('external.poweredBy')}</Text>
          <LogoExtendedIcon color="black" width={129} height={26} />
        </Box>
        <Text align="center" fz="sm" fw={400}>
          {t('external.footer')}
        </Text>
      </Stack>
    </Box>
  );
};
